import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useBodyStore = defineStore('body', () => {
  const classes = ref<any>({});

  const getClasses = (key: string)=> classes.value[key];

  const addBodyClassname = (className: string) => {
    document.body.classList.add(className);
  };

  const removeBodyClassName = (className: string) => {
    document.body.classList.remove(className);
  };

  const addBodyAttribute = (payload: { qualifiedName: string; value: string }) => {
    const { qualifiedName, value } = payload;
    document.body.setAttribute(qualifiedName, value);
  };

  const removeBodyAttribute = (payload: { qualifiedName: string }) => {
    const { qualifiedName } = payload;
    document.body.removeAttribute(qualifiedName);
  };

  const addDocumentAttribute = (payload: { qualifiedName: string; value: string }) => {
    const { qualifiedName, value } = payload;
    document.documentElement.setAttribute(qualifiedName,value);
  };

  const addDocumentStyles = (styles: Record<string, string>) => {
    Object.entries(styles).forEach(([prop, value]) => {
        document.documentElement.style.setProperty(prop, value);
    });
  };

  const addClassname = (payload: { position: string; className: string }) => {
    const { position, className } = payload;
    if (!classes.value[position]) {
      classes.value[position] = [className];
    } else {
      classes.value[position].push(className);
    }
  };

  return {
    getClasses,
    addBodyClassname,
    removeBodyClassName,
    addDocumentAttribute,
    addBodyAttribute,
    removeBodyAttribute,
    addDocumentStyles,
    addClassname,
  };
});
